import { useState } from 'react';

import { useClient } from '@entities/clients';
import differenceInMinutes from 'date-fns/differenceInMinutes';
import parseISO from 'date-fns/parseISO';

import { xhr } from '@shared/config';
import { usePopup } from '@shared/hooks';

import { useAvailablePeriod } from '@src/entities/available-periods';

export const useAssign = (id: number, clientId: number, onSuccess?: (id: number) => void) => {
	const { availablePeriod } = useAvailablePeriod(id);
	const { client } = useClient(clientId);
	const { popup } = usePopup();

	const [mode, setMode] = useState('ON');

	const onModeChange = (mode: string) => setMode(mode);

	const onAssign = async () => {
		if (!availablePeriod || !client) return;

		try {
			const data = {
				address: availablePeriod.address[0]?.id,
				start_time: availablePeriod.start_time,
				duration: differenceInMinutes(
					parseISO(availablePeriod.end_time),
					parseISO(availablePeriod.start_time)
				),
				user: client.user.id,
				consultation_type: availablePeriod.status.length > 1 ? mode : availablePeriod.status[0],
				note: '',
			};

			const res = await xhr.post(`/api/v1/schedules/schedule/subscribe_patient/`, data);

			if (!res.data) throw res;
			if (onSuccess) onSuccess(res.data.consultation_id);
			popup({ type: 'success', text: 'Клиент записан на консультацию' });
		} catch (error) {
			console.log(error);
			popup({ type: 'error', text: 'Ошибка записи' });
		}
	};
	return {
		onAssign,
		mode,
		onModeChange,
	};
};
